import { render, staticRenderFns } from "./Plagues.vue?vue&type=template&id=cab5c402"
import script from "./Plagues.vue?vue&type=script&lang=js"
export * from "./Plagues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports